import {
  DeleteItemCommandInput,
  GetItemCommandInput,
  PutItemCommandInput,
  QueryCommandInput,
  UpdateItemCommandInput,
} from '@aws-sdk/client-dynamodb';

export type MarshalledInput<T> = T extends PutItemInput
  ? PutItemCommandInput
  : T extends UpdateItemInput
  ? UpdateItemCommandInput
  : T extends DeleteItemInput
  ? DeleteItemCommandInput
  : T extends GetItemInput
  ? GetItemCommandInput
  : T extends QueryItemsInput
  ? QueryCommandInput
  : never;

type UnmarshalledData = Record<any, any>;

export interface PutItemInput
  extends Omit<PutItemCommandInput, 'Item' | 'ExpressionAttributeValues'> {
  Item: UnmarshalledData;
  ExpressionAttributeValues?: UnmarshalledData;
}

export interface UpdateItemInput
  extends Omit<
    UpdateItemCommandInput,
    'AttributeUpdates' | 'ExpressionAttributeValues' | 'Key'
  > {
  Key: UnmarshalledData;
  AttributeUpdates?: UnmarshalledData;
  ExpressionAttributeValues?: UnmarshalledData;
}

export interface DeleteItemInput
  extends Omit<DeleteItemCommandInput, 'Key' | 'ExpressionAttributeValues'> {
  Key: UnmarshalledData;
  ExpressionAttributeValues?: UnmarshalledData;
}

export interface GetItemInput extends Omit<GetItemCommandInput, 'Key'> {
  Key: UnmarshalledData;
}

export interface QueryItemsInput
  extends Omit<QueryCommandInput, 'ExpressionAttributeValues'> {
  ExpressionAttributeValues?: UnmarshalledData;
}

export type UnmarshalledInput =
  | PutItemInput
  | UpdateItemInput
  | GetItemInput
  | DeleteItemInput
  | QueryItemsInput;

export enum TableName {
  PolicyData = 'policy_data',
  LabeledData = 'labeled_data',
}
